export type IncidentSummary = {
  daysSince: number;
  recordDays: number;
  lastIncident: { title: string; link: string; ongoing: boolean };
};

const CLOSED_STATUSES = ['Resolved', 'Postmortem'];

const DAY_MS = 24 * 60 * 60 * 1000;

const wholeDays = (from: Date, to: Date) =>
  Math.floor((to.getTime() - from.getTime()) / DAY_MS);

export const summarizeIncidents = (xml: string, now: Date): IncidentSummary => {
  const doc = new DOMParser().parseFromString(xml, 'text/xml');
  const items = Array.from(doc.querySelectorAll('item')).map(item => ({
    title: item.querySelector('title')?.textContent ?? '',
    link: item.querySelector('link')?.textContent ?? '',
    pubDate: new Date(item.querySelector('pubDate')?.textContent ?? ''),
    latestStatus: new DOMParser()
      .parseFromString(
        item.querySelector('description')?.textContent ?? '',
        'text/html',
      )
      .querySelector('strong')
      ?.textContent?.trim(),
  }));
  const last = items[0];
  if (!last) {
    throw new Error('GitHub status feed contains no incidents');
  }
  const ongoing = !CLOSED_STATUSES.includes(last.latestStatus ?? '');

  return {
    daysSince: ongoing ? 0 : wholeDays(last.pubDate, now),
    recordDays: Math.max(
      0,
      ...items
        .slice(1)
        .map((older, i) => wholeDays(older.pubDate, items[i].pubDate)),
    ),
    lastIncident: { title: last.title, link: last.link, ongoing },
  };
};
